import React from 'react';
import ReplyPageContent from '../feature/replyPageContent/replyPageContent';

const ReplyPage: React.FC = () => {
    return (
        <ReplyPageContent />
    );
};

export default ReplyPage;